import { useContext } from 'react';

import { FormBuilderContext } from '../FormBuilder.context';

export const useFormBuilderContext = () => {
  const context = useContext(FormBuilderContext);

  if (context === undefined) {
    throw new Error(
      'Hook useFormBuilderContext must be used within a FormBuilderContextProvider component'
    );
  }

  return context;
};
